import Vue from 'vue';
import Vuetify from 'vuetify';
import App from './App.vue';
import router from './router';

import 'vuetify/src/stylus/app.styl';
import 'vuetify/src/stylus/theme.styl'
import 'vuetify/src/stylus/main.styl';

Vue.config.productionTip = false;

Vue.use(Vuetify, {
  theme: {
    primary: '#4b2c99',
    secondary: '#cfaa20',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
    shade: '#9c9c9c',
    light: '#ffffff'
  },
  iconfont: 'fa'
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
